export default () => {

  const $video = $('.video-background'),
        $toggle = $('.js-video-toggle')
  ;

  // Pause/Play Background Video
  function togglePlay() {
    $video.trigger($video.prop('paused') ? 'play' : 'pause');
    const playState = $video.prop('paused') ? 'pause' : 'play';
    $toggle
      .attr('data-state', playState)
      .find('.sr-text')
      .text(playState === 'pause' ? 'Play Video' : 'Pause Video');
  }

  $toggle.on('click', () => {
    togglePlay();
  });

};
